// extracted by mini-css-extract-plugin
export default {"textHeading":"services_textHeading__Li+FS","servText":"services_servText__2i12m","mainDiv":"services_mainDiv__GN6Ps"};